export { default } from "./ProductItem";
